import React from 'react';
import Img1 from '../../images/Weeping tiles/weeping_tiles.jpeg';
import { Link }  from 'react-router-dom';


export default () => (
	<div className='section3-CN'>

	<div class="service-split">
		<div>
		<h4>
		Weeping Tiles
		</h4>
		<p>
		Specializing in weeping tile services, Affordable Foundation Repair excels in drainage system installation and maintenance. Our expertise extends to porous pipe installation around foundations, redirecting water away from basements and foundation walls. Interior drainage solutions are also available to combat seepage, preventing water damage and foundation issues. Count on us for a dry, structurally sound foundation that safeguards your property.
		</p>
		</div>
	</div>	<div className='editorial-template'>
		<hr className="editorial-underline"></hr>
		<div class="project-split">
		<img class="service-split-img" src={Img1}></img>
	</div>
</div>
<Link to='/servicepage'>
			<button className="see-more-button">See More Services</button>
	</Link>
	</div>
);
